import { SVGProps } from 'react'

export const TinybirdIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 500 500"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      opacity="0.6"
      fill="#27F795"
      d="M500,42.8L343.9,0L289,122.7L500,42.8L500,42.8z M350.7,345.4l-142.9-51.1L123.9,500L350.7,345.4z"
    />
    <path fill="#27F795" d="M0,219.9l350.7,125.5l57.5-268.2L0,219.9L0,219.9z" />
  </svg>
)
